export default __webpack_public_path__ + "static/media/tshirts.5cf8d532.svg";